export const SMALL_FALLBACK_PRODUCT_IMAGE_URL =
  'https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/calculator/fallback_product_image.png/fallback_product_image.png';

export const LEMANAPRO_ROOT_URL = 'https://lemanapro.ru';
export const LAMINATE_SERVICE_PATH = '/uslugi/ukladka-laminata/';
export const LEMANAPRO_LAMINATE_SERVICE_URL = `${LEMANAPRO_ROOT_URL}${LAMINATE_SERVICE_PATH}`;
